import { cssVar, Icon, IconProps, keyframes } from '@chakra-ui/react';
import { ReactComponent as BrandLoaderIcon } from 'resources/images/brand-loader.svg';

const $border = cssVar('chakra-colors-borderBase');
const $bg = cssVar('chakra-colors-surface1');

const fade = keyframes`
  0% { color: ${$border.reference} }
  50% { color: ${$bg.reference} }
  100% { color: ${$border.reference} }
`;

export const BrandLoader = (props: IconProps) => {
  const animation = `${fade} infinite 1.5s`;

  return (
    <Icon
      as={BrandLoaderIcon}
      width="initial"
      height="initial"
      animation={animation}
      {...props}
    />
  );
};
